import { axiosClient, buildQuery } from '@nx-frontend/shared/api';
import { generalEnv } from '@nx-frontend/shared/env';
import { NoteDto } from '@nx-frontend/shared/types';
import { UpsertNotePayload } from '@nx-frontend/shared/types';

export async function upsertNote({
  noteServiceUrl,
  userId,
  workspaceId,
  noteId,
  isImport,
  isThirdPartyServiceImport,
  textVersion,
  skipNotesLimit,
  note,
}: UpsertNotePayload): Promise<NoteDto | null> {
  try {
    const queryParams = buildQuery({
      isImport,
      isThirdPartyServiceImport,
      textVersion,
      skipNotesLimit,
    });
    const query = queryParams ? `?${queryParams}` : '';
    const host = noteServiceUrl ?? generalEnv.noteServiceUrl;
    const response = await axiosClient.post<NoteDto>(
      `${host}/v1/workspaces/${workspaceId}/notes/${noteId}${query}`,
      note,
      {
        headers: {
          Authorization: `internal ${userId}:auto`,
        },
      }
    );
    return response.data;
  } catch (err) {
    console.log(`deleteNote error: ${err}`);
  }
  return null;
}
